import { render } from "./Lotto.vue?vue&type=template&id=6a978e08&scoped=true"
import script from "./Lotto.vue?vue&type=script&lang=js"
export * from "./Lotto.vue?vue&type=script&lang=js"

import "./Lotto.vue?vue&type=style&index=0&id=6a978e08&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a978e08"

export default script